import { Spin } from "antd";
import React, { ButtonHTMLAttributes } from "react";
import { Content } from './styles'

interface Props extends ButtonHTMLAttributes<HTMLButtonElement>{
    title: string;
    loading?: boolean;
}
export function Button({ title, loading= false, ...rest } : Props){
    return(
        <Content  { ...rest} disabled={loading || rest.disabled} loading={loading}>
            {
                loading
                ? <div className="loading"><Spin /></div>
                : title
            }
                    
        </Content>
    )
}